import React from 'react';

import { Follow as FollowButton } from '../common/input/Button.jsx';
import { Indicator as LoadingIndicator } from '../common/container/Loading.jsx';
import { ListArtworkAdd } from '../common/container/Popup.jsx';
import { Artwork as ArtworkSlider } from '../common/container/Slider.jsx';
import { Genre } from '../common/repository/Type.jsx';

let _ArtistsCategoryInst;
class ArtistsCategory extends React.Component {
    constructor(props) {
        super(props);

        let genre;
        const pathComponents = location.pathname.split('/');
        if (pathComponents && pathComponents.length > 0) {
            genre = pathComponents[pathComponents.length - 1];
        }

        this.state = {
            genre: Genre.values[genre] || {}
        };

        this.handleArtistFollowChange = this.handleArtistFollowChange.bind(this);
        this.handleArtworkLikeChange = this.handleArtworkLikeChange.bind(this);
        this.handleListArtworkAddModalClose = this.handleListArtworkAddModalClose.bind(this);
    }

    componentDidMount() {
        _ArtistsCategoryInst = true;

        const component = this;
        component.request = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.artists.get(),
            { genre: component.state.genre.value, limit: 20, offset: 0, type: 1 },
            function (responseData) {
                component.request = null;

                responseData.Artists.forEach(function (d) {
                    Artcloud.mkt.artists._isfollowing(d);
                });
                component.setState({
                    data: responseData.Artists
                });
            },
            function (jqXHR, textStatus) {
                component.request = null;
                component.setState({
                    data: []
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    componentWillUnmount() {
        _ArtistsCategoryInst = undefined;

        if (this.request) {
            this.request.abort();
            this.request = null;
        }
    }

    handleArtistFollowChange(d) {
        const data = this.state.data;
        let artist;
        for (let i = 0; i < data.length; i++) {
            let temp = data[i];
            if (!temp || temp.ArtistId != d.ArtistId) {
                continue;
            }
            artist = temp;
            break;
        }
        if (!artist) {
            return;
        }
        const component = this;
        Artcloud.mkt.artists.updateFollowing(artist.ArtistId, !artist.IsFollowing, artist.Name, function (success) {
            if (success != true || !_ArtistsCategoryInst) {
                return;
            }
            artist.IsFollowing = !artist.IsFollowing;
            component.setState({
                data: data
            });
        });
    }

    handleArtworkLikeChange(d) {
        if (!_ArtistsCategoryInst) {
            return;
        }
        this.setState({
            listArtworkAddModal: {
                data: d,
                visible: true
            }
        });
    }

    handleListArtworkAddModalClose() {
        this.setState({
            listArtworkAddModal: undefined
        });
    }

    render() {
        let sliders;
        if (this.state.data) {
            const component = this;
            sliders = component.state.data.map(function (d) {
                const titleContent = (
                    <div className="section__title section__title--small section__title--follow">
                        <a href={`/artist/${d.Slug}`}>
                            <h2>{d.Name}</h2>
                        </a>
                        <FollowButton data={d} onChange={component.handleArtistFollowChange} />
                    </div>
                );
                return (
                    <ArtworkSlider
                        key={d.ArtistId}
                        className="spacer--bottom"
                        hideOnEmpty={true}
                        id={d.ArtistId}
                        q={{ limit: 10, offset: 0 }}
                        slideProps={{ style: { minWidth: '115px' }, onLikeChange: component.handleArtworkLikeChange }}
                        titleContent={titleContent}
                        url={Artcloud.url.vendor.marketplace.artists.art.get(d.ArtistId)} />
                );
            });
        }
        return (
            <React.Fragment>
                <div className="header--highlight">
                    <div className="container">
                        <h1>{this.state.genre.display} Artists</h1>
                    </div>
                </div>
                <div className="section">
                    {sliders}
                    {
                        !this.state.data &&
                        <LoadingIndicator />
                    }
                </div>
                {
                    this.state.listArtworkAddModal &&
                    this.state.listArtworkAddModal.visible &&
                    <ListArtworkAdd data={this.state.listArtworkAddModal.data} onClose={this.handleListArtworkAddModalClose} />
                }
            </React.Fragment>
        )
    }
}

export default ArtistsCategory;